import { circle } from '@turf/circle';
import { Layer, Source } from 'react-map-gl/mapbox';

export type CircleRangeIndicatorProps = {
  lat?: number | null;
  lon?: number | null;
  range?: number;
};

export default function CircleRangeIndicator({
  lat,
  lon,
  range,
}: CircleRangeIndicatorProps) {
  const getGeoJSON = () => {
    if (!lat || !lon) {
      return 'empty';
    }
    const center = [lon, lat];
    const radius = (range ?? 0) / 1000;
    const options = {
      steps: 64,
      units: 'kilometers' as const,
      properties: {},
    };
    return circle(center, radius, options);
  };

  if (lat) {
    const RangeIndicatorLayerOutline = (
      <Layer
        id="circle-outline"
        key="circle-outline"
        type="line"
        paint={{
          'line-color': 'blue',
          'line-opacity': 0.1,
          'line-width': 1,
          'line-offset': 1,
        }}
      />
    );

    const RangeIndicatorLayerFill = (
      <Layer
        id="circle-fill"
        key="circle-fill"
        type="fill"
        paint={{
          'fill-color': 'blue',
          'fill-opacity': 0.1,
        }}
      />
    );

    return (
      <Source
        id="range_indicator_source"
        key="range_indicator_source"
        type="geojson"
        data={getGeoJSON()}
      >
        {RangeIndicatorLayerOutline}
        {RangeIndicatorLayerFill}
      </Source>
    );
  }

  return null;
}
